//
//
//
//
//
//
import HtmlPanel from "@/components/HtmlPanel";
export default {
  name: "index",
  components: {
    HtmlPanel: HtmlPanel
  },
  data: function data() {
    return {
      hospitalPhone: window.g.VUE_APP_PHONE,
      hospitalAddress: window.g.VUE_APP_ADDRESS,
      hospiatlName: window.g.VUE_APP_HOSPITALNAME,
      getPageUrl: window.g.VUE_APP_SUB_DIR + '/HtmlPanels/notice.html'
    };
  },
  created: function created() {},
  methods: {}
};